<template>
  <div class="liu-xuan-qr-code-popup"
       v-if="visible"
       @click.stop="handleClose(visible)"
  >
    <div class="qr-code">
      <img :src="qrCode"
           alt="二维码"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LiuXuanQrCodePopup',
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      qrCode: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      handleClose() {
        this.visible = false;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .liu-xuan-qr-code-popup {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: fade(@color-black, 40%);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }
  .qr-code {
    padding-top: 168px;
    padding-left: 205px;
    box-sizing: border-box;
    width: 620px;
    height: 562px;
    background: url('~@/assets/img/liuxuan-psychology/qr_code_bg.png') no-repeat;
    background-size: contain;
    img {
      display: block;
      width: 210px;
      height: 210px;
      border-radius: 10px;
    }
  }

</style>
